export default [{ id: 1, name: 'Member' }, { id: 2, name: 'Affiliate' }];
